import { errorMessages } from '@/core/api';

export const ERR_OUT_OF_MARKETPLACE = 'GraphQL Error: expert is not part of the marketplace';

export const MSG_OUT_OF_MARKETPLACE =
  "The team does not match the expert's marketplace preferences";

export const ERR_NOT_ENOUGH_CREDITS = 'GraphQL Error: not enough credits for consultation';

export const ERR_NO_BILLING_ACCOUNT =
  'GraphQL Error: no billing account associated with group or expert request';

export const ERR_REQUESTER_EQUALS_EXPERT = 'GraphQL Error: requester and expert cannot be the same';

// Crafted copy for the two refusals both booking flows (this one and
// SMBConsultationRequest) explain the same way. The api raises them under
// consultation.unknown, so only the message tells them apart. Reads the
// unprefixed GraphQL message, so it works for an ApolloError or an APIError.
const SHARED_REFUSAL_COPY: Record<string, string> = {
  [ERR_OUT_OF_MARKETPLACE]: `${MSG_OUT_OF_MARKETPLACE}.`,
  [ERR_REQUESTER_EQUALS_EXPERT]: 'Requester and expert cannot be the same.',
};

export function sharedRefusalCopy(err: unknown): string | undefined {
  const [message] = errorMessages(err);
  return SHARED_REFUSAL_COPY[`GraphQL Error: ${message}`];
}
